module.exports = __webpack_public_path__ + "img/active-star.48e0459.svg";